import {getContainer} from './getContainer';
import {SaveAndReloadMiniCart} from './cart';

export const switchEvent = 'switch:toggle';
const switchToggleEvent = new Event(switchEvent);

export function InitSwitches(container = document) {
    container = getContainer(container);
    const switches = container.querySelectorAll('button[role="switch"]:not(.disabled)');

    switches.forEach(button => {
        // Skip if this button has already been bound (InitSwitches runs on load and after every AJAX-refresh)
        if (button.dataset.switchBound) {
            return;
        }

        const labelId = button.getAttribute('aria-labelledby');
        // Het label binnen de eigen <li> zoeken: hetzelfde artikel kan meerdere keren op de pagina staan
        // (checkout stap 4: mobiel blok + desktop-sidebar, winkelmand: desktop + mobiel) met identieke label-ids.
        // document.getElementById() gaf dan altijd het eerste label terug en de overige knoppen bleven zonder handler.
        const scope = button.closest('li');
        const label = (scope && scope.querySelector('[id="' + labelId + '"]')) || document.getElementById(labelId);

        if (!label) {
            return;
        }

        button.addEventListener('click', (e) => toggleSwitch(button, e));
        label.addEventListener('click', (e) => toggleSwitch(button, e));

        button.dataset.switchBound = '1';
    });
}

const toggleSwitch = (button, event) => {
    const checked = button.getAttribute('aria-checked');
    const action = button.dataset.action;
    const articleno = button.getAttribute('data-articleno');
    const accessoryarticleno = button.getAttribute('data-accessoryarticleno');
    const cart = button.getAttribute('data-cart');
    const compare = button.getAttribute('data-compare');

    // For compare buttons, let compare.js handle the state
    if (compare) {
        // If click came from label, trigger the button click to activate compare handler
        if (event && event.target !== button && !button.contains(event.target)) {
            button.click();
        }
        // If click came from button itself, compare.js handler will take care of it
        return;
    }

    button.setAttribute('aria-checked', checked == 'false');
    button.dispatchEvent(switchToggleEvent);

    // Check for identical toggles and change their states too
    if (!cart) {
        let selector = '[data-action="' + action + '"][data-articleno="' + articleno + '"]';
        // For category accessories, also match on accessoryarticleno to avoid syncing all accessories
        if (action === 'categoryaccessory' && accessoryarticleno) {
            selector += '[data-accessoryarticleno="' + accessoryarticleno + '"]';
        }
        const mirrorButtons = document.querySelectorAll(selector);
        mirrorButtons.forEach(button => {
            button.setAttribute('aria-checked', checked == 'false');
        });
    }

    if (action && articleno) {
        if (cart) {
            $.post(strPath + 'ajax/cart-options.php', "lang=" + strLang + "&country=" + strCountry + "&articleno=" + articleno + "&checked=" + checked + "&action=" + action + "&accessoryarticleno=" + (accessoryarticleno || ''), function (data) {
                //window.location.reload();
                SaveAndReloadMiniCart();
            });
        } else {
            // Change all (hidden) input values
            if (action === 'categoryaccessory' && accessoryarticleno) {
                // Category accessory: manage comma-separated list of accessory articleno's
                document.getElementsByName('categoryaccessories').forEach(element => {
                    let currentValues = element.value ? element.value.split(',').filter(v => v) : [];
                    if (checked == 'false') {
                        // Add accessory if not already present
                        if (!currentValues.includes(accessoryarticleno)) {
                            currentValues.push(accessoryarticleno);
                        }
                    } else {
                        // Remove accessory
                        currentValues = currentValues.filter(v => v !== accessoryarticleno);
                    }
                    element.value = currentValues.join(',');
                });
            } else {
                // Standard toggle (guarantee, fullservice, appliance)
                if (checked == 'false') {
                    document.getElementsByName(action).forEach(element => {
                        element.value = "Y";
                    });
                } else {
                    document.getElementsByName(action).forEach(element => {
                        element.value = '';
                    });
                }
            }
        }
    }
};